module.exports = __webpack_public_path__ + "static/media/fb365.9b74413d.jpg";